import * as React from "react";
function SvgSnapchat(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        fill="#fff"
        stroke="currentColor"
        strokeWidth={1.01}
        d="M16.17 27h-.3a5.17 5.17 0 01-3.15-1.24 4.64 4.64 0 00-1.82-.93 6.43 6.43 0 00-1-.08 6.8 6.8 0 00-1.33.15 2.85 2.85 0 01-.49.07.32.32 0 01-.35-.24c0-.19-.09-.37-.13-.55-.1-.45-.17-.72-.36-.75-2.21-.34-2.84-.81-3-1.14a.57.57 0 010-.14.27.27 0 01.21-.26c3.4-.55 4.92-4 5-4.16h0a1.28 1.28 0 00.12-1.09c-.23-.54-1-.79-1.5-.94l-.33-.12c-1-.39-1.08-.8-1-1a1 1 0 01.89-.58.59.59 0 01.27 0 3 3 0 001.21.32 1.06 1.06 0 00.73-.23c0-.23 0-.47-.05-.72-.1-1.6-.22-3.59.28-4.72A6.15 6.15 0 0115.78 5h.47A6.15 6.15 0 0122 8.66c.51 1.13.38 3.12.28 4.72v.72a1 1 0 00.66.23h0A3.14 3.14 0 0024 14a.81.81 0 01.35-.07 1.07 1.07 0 01.41.08h0a.76.76 0 01.57.61c0 .23-.18.59-1.06.93l-.33.12c-.5.15-1.26.4-1.5.94a1.36 1.36 0 00.12 1.09h0c.06.14 1.59 3.6 5 4.16a.24.24 0 01.21.26.32.32 0 010 .14c-.14.33-.77.79-3 1.13-.18 0-.25.27-.35.76 0 .18-.08.35-.14.54a.28.28 0 01-.31.23h0a3 3 0 01-.5-.06 6.76 6.76 0 00-1.32-.14 6.22 6.22 0 00-1 .08 4.51 4.51 0 00-1.82.93A5.19 5.19 0 0116.17 27"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSnapchat);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
